import { render, staticRenderFns } from "./economy.vue?vue&type=template&id=c41987c0&scoped=true&"
import script from "./economy.vue?vue&type=script&lang=js&"
export * from "./economy.vue?vue&type=script&lang=js&"
import style0 from "./economy.vue?vue&type=style&index=0&id=c41987c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41987c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VSkeletonLoader})
